import { useEffect, useState, useCallback } from 'react';
import { Events } from 'react-scroll';

const Scroll = ({ to, label }: { to: string; label: string }) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById(to);
      if (section) {
        const { top, bottom } = section.getBoundingClientRect();
        const isActive =
          top < window.innerHeight * 0.25 && bottom > window.innerHeight * 0.25;
        setIsActive(isActive);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [to]);

  useEffect(() => {
    Events.scrollEvent.register('begin', function () {});
    Events.scrollEvent.register('end', function () {});
    return () => {
      Events.scrollEvent.remove('begin');
      Events.scrollEvent.remove('end');
    };
  }, []);

  const handleClick = useCallback(() => {
    const element = document.getElementById(to);
    if (!element) return;

    const getNavbarOffset = () => {
      const navbar =
        document.querySelector('[ref="stickyElementRef"]') ||
        document.querySelector('.fixed'); // Fallback selector

      if (navbar) {
        const navbarRect = navbar.getBoundingClientRect();
        return navbarRect.height + 20;
      }
      return 120;
    };

    const offset = getNavbarOffset();
    const elementPosition =
      element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }, [to]);

  return (
    <div
      className={`cursor-pointer no-underline text-sm md:hover:bg-[#f5f5f5] py-2 px-2 rounded-md w-max after:hidden md:after:block after:-bottom-0 after:left-2 after:right-2 after:!w-unset ${isActive && 'bg-[#ebebeb] md:hover:!bg-[#ebebeb]'}`}
      onClick={handleClick}
    >
      {label}
    </div>
  );
};

export default Scroll;
